// extracted by mini-css-extract-plugin
export default {"card":"CardVisitas_card__01gmH","container":"CardVisitas_container__Yxctr"};